const ChatIcons = () => {
	return (
		<svg
			className="inline ml-1"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16 6C16.3948 6 16.7809 5.88313 17.1094 5.6641L20 3.73704V13C20 13.5523 19.5523 14 19 14H18V16H19C20.6569 16 22 14.6569 22 13V3.73704C22 2.13965 20.2197 1.18686 18.8906 2.07294L16 4H9C7.34315 4 6 5.34315 6 7V8H8V7C8 6.44772 8.44772 6 9 6H16Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5.75061 18.4383C6.10524 18.1546 6.54586 18 7 18H15C15.5523 18 16 17.5523 16 17V11C16 10.4477 15.5523 10 15 10H5C4.44772 10 4 10.4477 4 11V19.8388L5.75061 18.4383ZM7 20H15C16.6569 20 18 18.6569 18 17V11C18 9.34315 16.6569 8 15 8H5C3.34315 8 2 9.34315 2 11V19.8388C2 21.5158 3.93986 22.4481 5.24939 21.4005L7 20Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M6 14C6 13.4477 6.44772 13 7 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H7C6.44772 15 6 14.5523 6 14Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default ChatIcons;
